import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  AddressMonitoringListRequest,
  MonitoringUnsubscribeRequest,
} from '@/api';
import { AddressMonitoringData, MonitoringAddressItem } from '@/redux/models';

export interface AddressMonitoringSliceState {
  data: AddressMonitoringData;
  loading: boolean;
  error: string | null;
}

const initialState: AddressMonitoringSliceState = {
  data: null,
  loading: false,
  error: null,
};

const addressMonitoringSlice = createSlice({
  name: 'addressMonitoring',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loading: action.payload,
    }),
    setError: (state, action: PayloadAction<string | null>) => ({
      ...state,
      error: action.payload,
    }),
    setData: (state, action: PayloadAction<AddressMonitoringData>) => ({
      ...state,
      data: action.payload,
    }),
    addData: (state, action: PayloadAction<AddressMonitoringData>) => {
      if (action.payload === null) {
        return {
          ...state,
          data: null,
        };
      }

      const currentItems = JSON.parse(JSON.stringify(state.data?.items || []));
      const { items, ...newData } = action.payload;

      return {
        ...state,
        data: {
          ...state.data,
          ...newData,
          items: [...currentItems, ...items],
        },
      };
    },
    fetchMonitoringList: (
      state,
      action: PayloadAction<AddressMonitoringListRequest>,
    ) => ({
      ...state,
      error: null,
      loading: true,
    }),
    unsubscribe: (
      state,
      action: PayloadAction<MonitoringUnsubscribeRequest>,
    ) => ({
      ...state,
      error: null,
      loading: true,
    }),
    refreshDataItem: (state, action: PayloadAction<MonitoringAddressItem>) => {
      if (state.data?.items) {
        const currentItems: MonitoringAddressItem[] = JSON.parse(
          JSON.stringify(state.data?.items || []),
        );
        const newItems = [...currentItems];

        if (action.payload) {
          const itemIndex = currentItems.findIndex(
            (item) => item.id === action.payload.id,
          );

          if (itemIndex !== -1) {
            newItems.splice(itemIndex, 1, action.payload);
          }
        }

        state.data.items = newItems;
      }
    },
  },
});

export { addressMonitoringSlice };
